import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs';
import { API_BASE_URL } from './api.config';
import { unwrapPagedList } from './paged-list';
import { ServiceRequest, ServiceRequestListItem, ServiceRequestSearchRequest } from '../../shared/models/service-request';

@Injectable({ providedIn: 'root' })
export class ServiceRequestService {
  constructor(private readonly http: HttpClient) {}

  search(request: ServiceRequestSearchRequest = { Page: 1, PageSize: 50 }) {
    return this.http.post<unknown>(`${API_BASE_URL}/mobile/ServiceRequestListSearch`, request).pipe(
      map(raw => unwrapPagedList<ServiceRequestListItem>(raw))
    );
  }

  get(id: string | number) {
    return this.http.get<ServiceRequest>(`${API_BASE_URL}/mobile/GetServiceRequest/${encodeURIComponent(String(id))}`);
  }
}
